import React from 'react';
import '../../App.css';

export const Home = () => {

    return (
        <div className="container">
            <div className='d-flex'>
                <h3 className="px-2 sidebet-title text-center">Service not available</h3>
            </div>
        </div>
    );
};
